import SEO from '../components/SEO'
import Hero from '../components/sections/Hero'
import Platforms from '../components/sections/Platforms'
import SocialProof from '../components/sections/SocialProof'
import Features from '../components/sections/Features'
import WhyIntervio from '../components/sections/WhyIntervio'
import HowItWorks from '../components/sections/HowItWorks'
import FAQ from '../components/sections/FAQ'
import Privacy from '../components/sections/Privacy'
import DownloadCTA from '../components/sections/DownloadCTA'

function HomePage() {
  return (
    <>
      <SEO
        path="/"
        rawTitle
        title="Intervio — Undetectable AI Interview Assistant | Real-Time Hints for Coding & Behavioral Interviews"
        description="Ace your next technical or behavioral interview with Intervio. Get invisible, real-time AI answer, depth & lateral hints hidden from Zoom, Teams & Meet screen sharing. Works with HackerRank, CodeSignal & LeetCode."
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Intervio',
          applicationCategory: 'ProductivityApplication',
          applicationSubCategory: 'InterviewAssistant',
          operatingSystem: 'macOS, Windows, Linux, Android',
          description: 'Undetectable AI interview assistant with real-time answer hints, invisible to Zoom/Teams/Meet screen sharing. Coding interview copilot for HackerRank, CodeSignal, LeetCode.',
          keywords: 'AI interview assistant, undetectable interview helper, coding interview copilot, screen share invisible, HackerRank helper, real-time interview hints',
          offers: [
            {
              '@type': 'Offer',
              price: '0',
              priceCurrency: 'USD',
              name: 'Free Trial',
              description: '3 hours of full access with all features included',
            },
            {
              '@type': 'Offer',
              price: '199',
              priceCurrency: 'USD',
              name: 'Pro Annual',
              description: '30 hours of session time per month, billed annually',
            },
          ],
          featureList: 'Real-time transcription, AI answer hints, Depth hints, Lateral hints, Screen OCR, Coding interview copilot, Question detection, Invisible to screen sharing, Cloud and local processing, Cross-platform',
        }}
      />
      <Hero />
      <Platforms />
      <SocialProof />
      <Features />
      <WhyIntervio />
      <HowItWorks />
      <FAQ />
      <Privacy />
      <DownloadCTA />
    </>
  )
}

export default HomePage
